import React from "react";
import { PaziaButton } from "components/atoms";
import { PaziaModal, TanTableClient } from "components/molecules";
import { CourseStudentExamData, courseExamsApi } from "api/course-exams";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { getStudentExamsColumns } from "./StudentExamsTable";
import { useToaster } from "utils";

interface SendExamResultsModalProps {
  onCloseRequest: () => void;
  students: CourseStudentExamData[];
  selected: number[];
  isOpen: boolean;
  courseId: number;
  courseExamId: number;
}

export const SendExamResultsModal = ({
  onCloseRequest,
  students,
  isOpen,
  selected,
  courseId,
  courseExamId,
}: SendExamResultsModalProps) => {
  const { showError, showSuccess } = useToaster();
  const onSend = async (selectedStudents: CourseStudentExamData[]) => {
    try {
      const students = selectedStudents.map((student) => ({
        userId: student.userId,
        userExamId: student.attempts[0].userExamId,
      }));
      await courseExamsApi.publishResults(courseId, students);
      onCloseRequest();
      showSuccess("Wyniki egzaminów zostały wysłane.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się wysłać wyników egzaminów.");
    }
  };
  return (
    <PaziaModal id="send-exam-results-modal" onCloseRequest={onCloseRequest} isOpen={isOpen} size="3xl">
      {isOpen && (
        <ModalBody
          onCancel={onCloseRequest}
          students={students.filter((student) => selected.includes(student.userId))}
          courseId={courseId}
          courseExamId={courseExamId}
          onSend={onSend}
        />
      )}
    </PaziaModal>
  );
};

const ModalBody = ({
  onCancel,
  students,
  courseId,
  courseExamId,
  onSend,
}: {
  onCancel: () => void;
  students: CourseStudentExamData[];
  courseId: number;
  courseExamId: number;
  onSend: (selectedStudents: CourseStudentExamData[]) => Promise<void>;
}) => {
  const columns = getStudentExamsColumns(courseId, courseExamId);

  return (
    <ModalPadding>
      <ModalHeader>Wyślij wyniki do kursantów</ModalHeader>
      <div>
        Wybrano <span className="font-semibold">{students.length}</span> kursantów
      </div>
      <div className="pb-4">
        <TanTableClient data={students} columns={columns} hideBorder />
      </div>
      <div className="flex justify-end gap-2">
        <PaziaButton title="Anuluj" type="tertiary" btnType="button" onClick={onCancel} />
        <PaziaButton type="success" onClick={() => onSend(students)}>
          Wyślij
        </PaziaButton>
      </div>
    </ModalPadding>
  );
};
